import {createRouter, createWebHashHistory, RouteRecordRaw} from 'vue-router'
import HomeView from '@/views/HomeView.vue';
import NoticeView from "@/views/NoticeView.vue";
import NoticeInfo from "@/components/notice-info.vue";
import ThirdPartyLogin from "@/components/third-party-login.vue";
import InternationalDownload from "@/components/international-download.vue";
import ProjectView from "@/views/ProjectView.vue";
import GoogleAuthenticatorView from "@/views/GoogleAuthenticatorView.vue";

const lan = localStorage.getItem('lang') ||  'zh_CN';

const routes: Array<RouteRecordRaw> = [
    {
      path: '/',
      redirect:`/${lan}`
    },
    {
        path: '/:lang',
        name: 'home',
        component: HomeView,
    },
    {
        path: '/:lang/notice',
        name: 'notice',
        component: NoticeView
    },
    {
        path: '/:lang/project',
        name: 'project',
        component: ProjectView
    },
    {
        path: '/:lang/GoogleAuthenticator',
        name: 'GoogleAuthenticator',
        component: GoogleAuthenticatorView
    },
    {
        path: '/:lang/notice_info/:id',
        name: 'NoticeInfo',
        component: NoticeInfo
    },
    {
        path: '/:lang/international_download',
        name: 'InternationalDownload',
        component: InternationalDownload
    },
    {
        path: '/:lang/third-party-login',
        name: 'ThirdPartyLogin',
        component: ThirdPartyLogin
    }
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router;

